import { ApiError } from '@/openapi';
import { useCallback, useEffect, useState } from 'react';

type RemoteMethod<T> = () => Promise<T> | undefined;

type UseRemoteGetProps<T> = {
	remoteMethod: RemoteMethod<T>;
	lazy: boolean;
};

export const useRemoteGet = <T>({ remoteMethod, lazy }: UseRemoteGetProps<T>) => {
	const [data, setData] = useState<T | undefined>(undefined);
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<string | undefined>(undefined);

	const getRemoteContent = useCallback(async () => {
		try {
			setLoading(true);
			const result = await remoteMethod();
			if (result !== undefined) {
				setData(result);
				setError(undefined);
			}
		} catch (e) {
			if (e instanceof ApiError) {
				setError(e.message);
			} else if (e instanceof Error) {
				setError(e.message);
			} else {
				setError('Errore sconosciuto durante il recupero dei dati');
			}
		} finally {
			setLoading(false);
		}
	}, [remoteMethod]);

	useEffect(() => {
		if (!lazy) {
			getRemoteContent();
		}
	}, [lazy, getRemoteContent]);

	return {
		data,
		loading,
		error,
		fetch: getRemoteContent
	};
};
